// extracted by mini-css-extract-plugin
export default {"link":"kE-z","disabled":"lE-z"};